import { PropsWithChildren, useMemo } from 'react';
import styles from './AccordionHeaderFaults.module.scss';
import AssetWidget from '@customer/components/asset-data/asset-widget/AssetWidget';
import { useTranslation } from 'react-i18next';
import { FaultLevel } from '@customer/store/slices/globalSlice';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';

export interface AccordionHeaderFaultProps {
  level: FaultLevel;
  percentage: number;
  totalCount: number;
  defaultExpanded?: boolean;
}

export function AccordionHeaderFaults({
  level,
  percentage,
  totalCount,
}: PropsWithChildren<AccordionHeaderFaultProps>) {
  const { t } = useTranslation();
  const { getNumberPercentText } = useLocaleFormatter();

  const barColor = useMemo<string>(() => {
    switch (level) {
      default:
      case FaultLevel.One:
        return 'var(--static-red-500)';
      case FaultLevel.Two:
        return 'var(--static-orange-500)';
      case FaultLevel.Three:
        return 'var(--static-yellow-500)';
    }
  }, [level]);

  return (
    <div className={styles.header}>
      <div className={styles.header__bar}>
        <AssetWidget title={t('PercentageTimeInLevelFault', { level })} width="300px">
          <div>{getNumberPercentText(percentage)}</div>
          <div
            className={styles.percentagebar}
            style={{ width: `${percentage * 100}%`, background: barColor }}
          />
        </AssetWidget>
      </div>
      <div className={styles.header__faults}>
        <AssetWidget title={t('FaultCounts', { level })} alignEnd textAlign="right">
          {totalCount}
        </AssetWidget>
      </div>
    </div>
  );
}

export default AccordionHeaderFaults;
